type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

let lagretPrompt: BeforeInstallPromptEvent | null = null;
let installert = false;

const tilgjengelighetListeners = new Set<(tilgjengelig: boolean) => void>();

export function startInstallasjonsLytter(): void {
  if (typeof window === 'undefined') return;

  installert = erInstallert();

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    lagretPrompt = event as BeforeInstallPromptEvent;
    emit(true);
  });

  window.addEventListener('appinstalled', () => {
    lagretPrompt = null;
    installert = true;
    emit(false);
  });
}

export function kanInstallere(): boolean {
  return lagretPrompt !== null && !installert;
}

export function erInstallert(): boolean {
  if (typeof window === 'undefined') return false;
  if (installert) return true;
  if (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches
  ) {
    return true;
  }
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true;
}

export async function triggerInstallPrompt(): Promise<'accepted' | 'dismissed' | 'unavailable'> {
  if (!lagretPrompt) return 'unavailable';
  try {
    await lagretPrompt.prompt();
    const valg = await lagretPrompt.userChoice;
    lagretPrompt = null;
    emit(false);
    return valg.outcome;
  } catch {
    lagretPrompt = null;
    emit(false);
    return 'dismissed';
  }
}

export function abonnerInstallTilgjengelig(
  cb: (tilgjengelig: boolean) => void,
): () => void {
  tilgjengelighetListeners.add(cb);
  cb(kanInstallere());
  return () => tilgjengelighetListeners.delete(cb);
}

function emit(tilgjengelig: boolean): void {
  tilgjengelighetListeners.forEach((cb) => cb(tilgjengelig));
}
